firebird.factory('questionService', [
    '$rootScope',
    'socketService',
    'notificationService',
    'localizationService',
    function ($rootScope, socketService, notificationService, localizationService) {
        var self = this;

        self.questions = [];
        self.newQuestions = [];
        self.answeredQuestions = [];
        self.ignoredQuestions = [];
        self.isInQandAMode = false;
        self.currentQuestion = null;
        self.initialized = false;

        var service = {
            getNewQuestions: getNewQuestions,
            getAnsweredQuestions: getAnsweredQuestions,
            getIgnoredQuestions: getIgnoredQuestions,
            addQuestion: addQuestion,
            editQuestion: editQuestion,
            markQuestionAsIgnored: markQuestionAsIgnored,
            markQuestionAsAnswered: markQuestionAsAnswered,
            markQuestionAsNew: markQuestionAsNew,
            refreshQuestions: refreshQuestions,
            onQuestionUpdated: onQuestionUpdated,
            onQuestionAdded: onQuestionAdded,

            getIsInQandAMode: getIsInQandAMode,
            setIsInQandAMode: setIsInQandAMode,

            setCurrentQuestion: setCurrentQuestion,
            getCurrentQuestion: getCurrentQuestion,

            nextQuestion: nextQuestion,

            isOnLastQuestion: isOnLastQuestion,
            startQandAMode: startQandAMode,
            stopQandAMode: stopQandAMode
        };

        $rootScope.$on('question-updated', onQuestionUpdated);
        $rootScope.$on('question-added', onQuestionAdded);
        $rootScope.$on('question-ignored', onQuestionIgnored);
        $rootScope.$on('question-answered', onQuestionAnswered);
        $rootScope.$on('question-marked-as-new', onQuestionMarkedAsNew);
        $rootScope.$on('questions-retrieved', onQuestionsRetrieved);
        $rootScope.$on('promoted-to-presenter', onPromotedToPresenter);
        $rootScope.$on('demoted-to-attendee', onDemotedToAttendee);

        return service;

        ////////////////////////

        function onPromotedToPresenter() {
            var msgObj = {
                message: 'retrieve-questions',
                data: {}
            };

            socketService.send(msgObj);
        }

        function onDemotedToAttendee() {
            self.questions = [];
            self.newQuestions = [];
            self.answeredQuestions = [];
            self.ignoredQuestions = [];
        }

        function setCurrentQuestion(question) {
            self.currentQuestion = question;
        }

        function getCurrentQuestion(question) {
            return self.currentQuestion;
        }

        function getIsInQandAMode() {
            if (!self.initialized) {
                var msgObj = {
                    message: 'get-active-question',
                    data: {}
                };

                socketService.send(msgObj);
                self.initialized = true;
            }

            return self.isInQandAMode;
        }

        function setIsInQandAMode(inQandAMode) {
            self.isInQandAMode = inQandAMode;
        }

        function startQandAMode(question) {
            self.currentQuestion = question;

            markQuestionAsAnswered(self.currentQuestion);

            var msgObj = {
                message: 'start-qa-mode',
                data: question
            };

            socketService.send(msgObj);
        }

        function stopQandAMode(question) {
            self.currentQuestion = null;

            var msgObj = {
                message: 'stop-qa-mode',
                data: {}
            };

            socketService.send(msgObj);
        }

        function findNextUnansweredQuestion() {
            var index = findQuestionIndex(self.questions, self.currentQuestion);
            if (index < 0) {
                return -1;
            }
            var nextIndex = -1;
            for (var i = index + 1; i < self.questions.length; i++) {
                if (self.questions[i].ignored === false && self.questions[i].answered === false) {
                    nextIndex = i;
                    break;
                }
            }
            return nextIndex;
        }

        function nextQuestion() {
            if (self.currentQuestion === null) {
                return;
            }

            var nextQuestionIndex = findNextUnansweredQuestion();
            if (nextQuestionIndex > 0) {
                startQandAMode(self.questions[nextQuestionIndex]);
            }
        }

        function isOnLastQuestion() {
            var nextQuestionIndex = findNextUnansweredQuestion();
            if (nextQuestionIndex < 0) {
                return true;
            }
            return false;
        }

        function refreshQuestions(questions) {
            self.newQuestions = questions.filter(function (question) {
                return question.ignored !== true && question.answered !== true;
            });
            self.ignoredQuestions = questions.filter(function (question) {
                return question.ignored === true;
            });
            self.answeredQuestions = questions.filter(function (question) {
                return question.answered === true;
            });
            generateQuestionNumbering();
            $rootScope.$broadcast('question-lists-updated');
        }

        function onQuestionUpdated(evt, question) {
            //data is returned as a long list
            //separate them into individual lists
            var index = findQuestionIndex(self.questions, { qaid: question.qaid });
            if (index < 0) {
                return;
            }
            self.questions[index] = question;

            refreshQuestions(self.questions);
            notificationService.show(localizationService.translate('Q_AND_A.QUESTION_EDITED'), 'success');
        }

        function onQuestionAdded(evt, question) {
            self.questions.push(question);
            refreshQuestions(self.questions);
            notificationService.show(
                localizationService.translate('Q_AND_A.QUESTION_ADDED_BY_PERSON', { person: question.attendantName }),
                'qanda'
            );
        }

        function onQuestionIgnored(evt, qaid) {
            var index = findQuestionIndex(self.questions, { qaid: qaid });
            if (index < 0) {
                return;
            }
            self.questions[index].ignored = true;
            refreshQuestions(self.questions);
        }

        function onQuestionAnswered(evt, qaid) {
            var index = findQuestionIndex(self.questions, { qaid: qaid });
            if (index < 0) {
                return;
            }
            self.questions[index].answered = true;
            refreshQuestions(self.questions);
        }

        function onQuestionMarkedAsNew(evt, qaid) {
            var index = findQuestionIndex(self.questions, { qaid: qaid });
            if (index < 0) {
                return;
            }
            self.questions[index].ignored = false;
            self.questions[index].answered = false;
            refreshQuestions(self.questions);
        }

        function onQuestionsRetrieved(evt, questions) {
            self.questions = questions;
            refreshQuestions(questions);
        }

        function getNewQuestions() {
            return self.newQuestions;
        }

        function getAnsweredQuestions() {
            return self.answeredQuestions;
        }

        function getIgnoredQuestions() {
            return self.ignoredQuestions;
        }

        function generateQuestionNumbering() {
            for (var i = 0; i < self.newQuestions.length; ++i) {
                self.newQuestions[i].ordering = i;
            }
        }

        function findQuestionIndex(list, item) {
            if (item !== null) {
                for (var i = 0; i < list.length; i++) {
                    //sometimes strings and numbers are compared...
                    //so double equals is intentional
                    if (list[i].qaid == item.qaid) {
                        return i;
                    }
                }
            }

            return -1;
        }

        function markQuestionAsNew(question) {
            var index = findQuestionIndex(self.questions, question);
            if (index < 0) {
                return;
            }
            sendQandAOperation('marked-question-as-new', question);
        }

        function markQuestionAsAnswered(question) {
            var index = findQuestionIndex(self.questions, question);
            if (index < 0) {
                return;
            }
            sendQandAOperation('marked-question-as-answered', question);
        }

        function markQuestionAsIgnored(question) {
            var index = findQuestionIndex(self.questions, question);
            if (index < 0) {
                return;
            }
            sendQandAOperation('marked-question-as-ignored', question);
        }

        function sendQandAOperation(message, data) {
            var msgObj = {
                message: message,
                data: data
            };

            socketService.send(msgObj);
        }

        function addQuestion(question) {
            sendQandAOperation('add-question', question);
        }

        function editQuestion(question) {
            sendQandAOperation('edit-question', question);
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
